import WarehouseIcon from '@mui/icons-material/Warehouse';

export const warehouseAutomationWorkflowsConfig = {
    all:  {
        title: 'all',
        icon: <WarehouseIcon/>,
        isSingleDataGrid: true,
    },
};
